/**
 * Q276(사용자 결정 2026-10-13) — 메뉴 › 세계 › **세계 수명**.
 * 신전 창의 「이 세계」와 봉헌 순위를 그대로 부른다(값·문장은 temple.js 한 곳). 바치기는 마을 신전에서 한다.
 */
import { stateKey as lifeStateKey, worldLifeSections } from './temple.js';
import { S, esc } from '../../core/state.js';
import { num } from './common.js';
import { carryHtml, vaultFateText, worldLeftLabel, worldLeftSecs } from '../world-end-notice.js';
import { levelLabel } from '../../core/level-label.js';

export function stateKey() {
  const y = S.you;
  return `${lifeStateKey()}:${JSON.stringify([y?.level, y?.kills, y?.worldsSeen, y?.power, y?.carry])}`;
}

export function render() {
  const y = S.you, left = worldLeftSecs();
  const title = Number(S.world?.n) > 0 ? `제 ${num(S.world.n)} 세계에서` : '이 세계에서';
  const journey = y ? `<div class="ux-facts">${Number.isFinite(y.level) ? `<span class="ux-fact">나의 레벨 <b class="ux-number">${levelLabel(y.level)}</b></span>` : ''}`
    + `${Number.isFinite(y.kills) ? `<span class="ux-fact">처치 <b class="ux-number">${num(y.kills)}</b></span>` : ''}`
    + `${Number.isFinite(y.worldsSeen) ? `<span class="ux-fact">세계 참여 <b><span class="ux-number">${num(y.worldsSeen)}</span><small>회</small></b></span>` : ''}</div>` : '';
  const carry = carryHtml(y);
  return `<section class="ux-hero"><span class="ux-kicker">내 여정과 세계</span><h3 class="ux-title">${title}</h3>`
    + `<p class="ux-summary">${left === null ? '세계의 남은 시간을 확인 중이다.' : `함께 살아갈 시간 ${worldLeftLabel(left)}`}</p>${journey}</section>`
    + `<section class="sec"><h3>다음 세계로 이어지는 것</h3>${carry ? `<p>${carry}</p>` : ''}<p class="qt">${esc(vaultFateText(y))}</p>`
    + '<p class="qt">이름·도감·집·길드는 남고, 캐릭터는 1레벨부터 다시 시작한다.</p></section>'
    + worldLifeSections(false)
    + '<div class="ux-actions"><button onclick="act.openPanel(\'hall\')">지난 세계 한 편 돌아보기</button><button class="ghost" onclick="act.openPanel(\'tomb\')">비석의 공동 기록 읽기</button></div>';
}
